import {
  GetQuestionListActionTypes,
  GET_QUESTION_LIST_FAIL,
  GET_QUESTION_LIST_LOADING,
  GET_QUESTION_LIST_SUCCESS,
  GetQuestionListState,
  GET_QUESTION_LIST_API_MSG,
  GET_QUESTION_LIST_API_RES,
} from "./ActionTypes";
import { GetQuestionListRes } from "./Model";

const initialStateEditPosts: GetQuestionListState = {
  loading: false,
  getQuestionListRes: {} as GetQuestionListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getQuestionListReducer = (
  state = initialStateEditPosts,
  action: GetQuestionListActionTypes
): GetQuestionListState => {
  switch (action.type) {
    case GET_QUESTION_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_QUESTION_LIST_SUCCESS:
      return {
        ...state,
        getQuestionListRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_QUESTION_LIST_FAIL:
      return {
        ...state,
        getQuestionListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_QUESTION_LIST_API_MSG:
      return {
        ...state,
        getQuestionListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_QUESTION_LIST_API_RES:
      return {
        ...state,
        getQuestionListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
